import {
    renderComponent,
    renderPage,
} from './components/migration/MigrationRoot';

const componentFunctions = {
    renderFooter: renderComponent(() => import('./components/footer/Footer')),
    renderNtcLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/ntc/NtcLibbyFooterPromo'
            )
    ),
    renderTourismLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/tourism/TourismLibbyFooterPromo'
            )
    ),
    renderGenericLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/generic/GenericLibbyFooterPromo'
            )
    ),
    renderSampleOnlyBanner: renderComponent(
        () => import('./components/banner/SampleOnlyBanner')
    ),
    renderNtcCarousel: renderComponent(
        () => import('./ntc/components/carousel/NtcCarousel')
    ),
};

const pageFunctions = {
    renderNtcCheckout: renderPage(
        () => import('./ntc/components/checkout/NtcCheckout')
    ),
    renderNtcFaqPage: renderPage(
        () => import('./ntc/pages/NtcFaqPage/NtcFaqPage')
    ),
    renderNtcHomePage: renderPage(
        () => import('./ntc/pages/NtcHomePage/NtcHomePage')
    ),
    renderOdAppSunsetPage: renderPage(
        () =>
            import(
                './overdrive-app/components/od-app-sunset-message/OdAppSunsetPage'
            )
    ),
    renderDetailsPageProviderGrid: renderPage(
        () =>
            import(
                './ntc/components/detailsPageProviderGrid/DetailsPageProviderGrid'
            )
    ),
};

document.dispatchEvent(
    new CustomEvent('react-components-ready', {
        detail: componentFunctions,
    })
);

document.dispatchEvent(
    new CustomEvent('react-pages-ready', {
        detail: pageFunctions,
    })
);
